module.exports = __webpack_public_path__ + "static/btob-41be1e01ca67773a47128365c2fb3f2c.jpg";